import React from 'react'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'

import { ModalConfirm } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { modalConfirmChangeDefaultMessageState } from '../recoil/state/modal'
import { setActiveMessageCallback } from '../recoil/callbacks/callbacks'
import {
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_WELCOME
} from '../../../constants/index'
import { messageState } from '../recoil/state/message'

const ModalConfirmChangeDefault = () => {
  const intl = useIntl()

  const setActive = useRecoilCallback(setActiveMessageCallback, [])

  const { show } = useRecoilValue(modalConfirmChangeDefaultMessageState)
  const { messageType } = useRecoilValue(messageState)
  const resetModal = useResetRecoilState(modalConfirmChangeDefaultMessageState)

  const getMessage = () => {
    if (messageType === MESSAGE_STR_TYPE_CONFIRMATION) {
      return intl.formatMessage({
        id: 'Load.ModalNotificationAsDefaultConfirm.Description'
      })
    } else if (messageType === MESSAGE_STR_TYPE_WELCOME) {
      return intl.formatMessage({
        id: 'Load.ModalNotificationAsDefaultWelcome.Description'
      })
    }
  }

  return (
    <ModalConfirm
      show={show}
      showClose
      closeOnOverlayClick
      title={intl.formatMessage({
        id: 'Load.ModalNotificationAsDefaultConfirm.Title'
      })}
      message={getMessage()}
      stringConfirm={intl.formatMessage({
        id: 'Load.ModalNotificationAsDefaultConfirm.MainAction'
      })}
      onClickConfirm={setActive}
      stringCancel={intl.formatMessage({
        id: 'Load.ModalNotificationAsDefaultConfirm.CancelBtn'
      })}
      onClickCancel={resetModal}
      variant='primary'
    />
  )
}

export default ModalConfirmChangeDefault
